/* Sale countdown. Dates come from Theme settings and are read as Pakistan time (UTC+5, no daylight saving),
   so the countdown is correct whatever time zone the visitor's phone is set to. */
(function () {
  'use strict';

  if (customElements.get('sale-countdown')) return;

  function parse(str) {
    var m = String(str || '')
      .trim()
      .match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 5, +m[5] || 0, +m[6] || 0);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.start = parse(this.dataset.start);
      this.end = parse(this.dataset.end);
      if (isNaN(this.end)) {
        this.hidden = true;
        return;
      }
      if (isNaN(this.start)) this.start = this.end;

      this.fields = {
        d: this.querySelector('[data-d]'),
        h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'),
        s: this.querySelector('[data-s]'),
      };
      this.labelEl = this.querySelector('[data-label]');
      this.mode = '';

      this.tick = this.tick.bind(this);
      this.onVisibility = () => {
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    setMode(mode) {
      if (this.mode === mode) return;
      this.mode = mode;
      this.dataset.mode = mode;
      var label = mode === 'live' ? this.dataset.labelLive : mode === 'ended' ? this.dataset.labelAfter : this.dataset.labelBefore;
      if (this.labelEl && label) this.labelEl.textContent = label;
    }

    set(el, value) {
      if (!el || el.textContent === value) return;
      el.textContent = value;
      /* replay the little "tick" animation on the digits that changed */
      el.classList.remove('is-tick');
      void el.offsetWidth;
      el.classList.add('is-tick');
    }

    tick() {
      var now = Date.now();
      var target;
      if (now < this.start) {
        this.setMode('before');
        target = this.start;
      } else if (now < this.end) {
        this.setMode('live');
        target = this.end;
      } else {
        this.setMode('ended');
        clearInterval(this.timer);
        if (this.dataset.hideAfter === 'true') {
          this.hidden = true;
          var wrapper = this.closest('.shopify-section');
          if (wrapper && !document.documentElement.classList.contains('shopify-design-mode')) wrapper.hidden = true;
        }
        ['d', 'h', 'm', 's'].forEach((k) => this.set(this.fields[k], '00'));
        return;
      }
      var left = Math.max(0, Math.floor((target - now) / 1000));
      this.set(this.fields.d, pad(Math.floor(left / 86400)));
      this.set(this.fields.h, pad(Math.floor((left % 86400) / 3600)));
      this.set(this.fields.m, pad(Math.floor((left % 3600) / 60)));
      this.set(this.fields.s, pad(left % 60));
    }
  }

  customElements.define('sale-countdown', SaleCountdown);
})();
